(function ($) {
  function _resizeAbstractCaption() {
    $('.look-book__slide__image').each(function () {
      var thisHeight = $(this).height();

      if (thisHeight) {
        var $slickDotsButtons = $('.look-book__action_buttons');

        $slickDotsButtons.css('top', thisHeight);
      }
    });
  }

  Drupal.behaviors.LookBook = {
    attach: function (context) {
      var $modules = $('.look-book', context);

      $modules.each(function () {
        var $module = $(this),
          $slickWrapper = $('.look-book__inner', $module),
          $slides = $('.look-book__slide', $slickWrapper),
          $nav = $('.look-book__panel__nav', $module),
          $actionButton = $('.look-book__action_buttons_slick-action', $module);
        var _setStyles = function (index) {
          index = index || 0;
          var $slide = $slides.eq(index);

          // It can also control the color of the carousel arrows
          $module.toggleClass('look-book--light-arrows', !!$slide.data('light-arrows'));
          $module.toggleClass('lb-light-theme', !!$slide.data('light-theme'));
        };
        var numSlides = $slides.length;

        if (numSlides > 1) {
          $slickWrapper.slick({
            fade: true,
            autoplay: false,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            dots: true,
            dotsClass: 'look-book__action_buttons_slick-dots',
            appendDots: $('.look-book__action_buttons .look-book__action_buttons_wrapper', $module),
            prevArrow: $('.slick-prev', $module),
            nextArrow: $('.slick-next', $module),
            accessibility: true,
            onBeforeChange: function (slickSlider, slideIndex, futureSlideIndex) {
              _setStyles(futureSlideIndex, $module, $slides);
            },
            onInit: function () {
              _setStyles();
            }
          });

          $('.slick-prev, .slick-next', $module).once('slick-nav-buttons').on('click', function () {
            // Stop autoplay once the user interacts with the carousel
            if ($actionButton.is('.pause')) {
              $slickWrapper.slickPause();
              $actionButton.addClass('play').removeClass('pause');
            }
          });
          _resizeAbstractCaption();

          $actionButton.on('click', function () {
            // Stop/Start autoplay once the user click on action button
            $(this).toggleClass(function () {
              if ($(this).is('.pause')) {
                $slickWrapper.slickPause();
                $(this).addClass('play');

                return 'pause';
              } else {
                $slickWrapper.slickPlay();
                $(this).addClass('pause');

                return 'play';
              }
            });
          });
        } else {
          $nav.hide();
        }
      }); // end each

      _resizeAbstractCaption();

      // Reapply on resize.
      $(window).resize(_.debounce(function () {
        _resizeAbstractCaption();
      }, 300));
    }
  };
})(jQuery);
